import { Component, Input } from '@angular/core';
import { Share, UserDetail } from '@ca/core/models';
import { ResultsService, UserNotificationService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'ca-result-share-with-user-modal',
    templateUrl: './result-share-with-user-modal.component.html',
    styleUrls: ['./result-share-with-user-modal.component.scss'],
})
export class ResultShareWithUserModalComponent {
    @Input() share: Share;

    constructor(
        private activeModal: NgbActiveModal,
        private resultsService: ResultsService,
        private userNotificationService: UserNotificationService,
    ) {}

    save(share: Share): void {
        this.userNotificationService.showSpinner();
        this.resultsService
            .shareResult$(
                share.id,
                'User',
                share.users.map((user: UserDetail) => user.id),
            )
            .pipe(
                tap(() => {
                    this.userNotificationService.hideSpinner();
                    this.userNotificationService.showSuccess('MY_WORKSPACE.MY_RESULTS.SHARING.SUCCESS');
                    this.activeModal.close(share.users);
                }),
                catchError(() => {
                    this.userNotificationService.hideSpinner();
                    this.userNotificationService.showError('MY_WORKSPACE.MY_RESULTS.SHARING.ERROR');
                    return EMPTY;
                }),
                untilDestroyed(this),
            )
            .subscribe();
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }
}
